import React from "react";
import { Section } from "@/types/common";

import { Card } from "../Card/Card";
import SectionHeading from "../SectionHeading/SectionHeading";
// import { articleData } from "@/services/dummay";

export const FeaturedNewsSection = ({ data }: { data: Section }) => {
  // if (data && data.articles && data.articles.length === 0) {
  //   data.articles = articleData;
  // }
  const featuredArticles = data.articles?.slice(0, 5) || [];

  return (
    <section
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8  xl:px-0 scroll-mt-[100px] scroll-smooth"
      data-template={data.template}
      id={data.label?.split(" ").join("-")}
    >
      {/* <h2 className="text-3xl font-bold mb-8">{data.title}</h2> */}
      <div className="">
        <SectionHeading title={data.label || ""} />
      </div>
      {(!data.articles || data.articles.length === 0) ? (
        <div className="text-center py-8 text-gray-500">
          No articles available!
        </div>
      ) : (
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-4 h-full">
        {/* Main Featured Post */}
        <div className="col-span-1 lg:col-span-7 relative border-r-0 lg:border-r-0.5 lg:border-border lg:pr-4 border-b border-border md:border-b-0">
          <Card
            data={featuredArticles[0]}
            title="medium"
            description="large"
            titleSize="featured"
            descriptionSize="small"
            descriptionLineClamp="five"
            textOnImage={false}
            imageStyle="rounded"
            titleMargin="medium"
            priority={true}
            sizes="(max-width: 639px) calc(100vw - 2rem), (max-width: 1023px) calc(100vw - 3rem), (max-width: 1279px) calc((((100vw - 4rem) * 7) - 5rem) / 12 - 1rem), 724px"
          />
        </div>

        {/* Secondary Posts Grid */}
        <div className="col-span-1 lg:col-span-5 w-full h-full flex flex-col gap-4 sm:gap-6">
          <div className="flex flex-col md:flex-row lg:flex-row gap-4 w-full h-full">
            <div className="flex flex-col gap-6 md:w-[calc(50%-0.5rem)] lg:w-[calc(50%-0.5rem)] border-r-0 md:border-r-0.5 border-border md:pr-4">
              {featuredArticles.slice(1, 3).map((article, index) => (
                <div
                  className="border-b-0.5 border-border md:last:border-b-0"
                  key={index}
                >
                  <Card
                    data={article}
                    title="medium"
                    layout="vertical"
                    textOnImage={false}
                    titleSize="medium"
                    description="small"
                    descriptionSize="large"
                    imageStyle="rounded"
                    hideImage={index === 1}
                    descriptionLineClamp="four"
                    titleLineClamp="three"
                    priority={false}
                    sizes="(max-width: 639px) calc(100vw - 2rem), (max-width: 767px) calc(100vw - 3rem), (max-width: 1023px) calc((100vw - 3rem) / 2 - 1.5rem), (max-width: 1279px) calc(((5 * (100vw - 4rem)) - 7rem) / 24 - 1.5rem), 238px"
                    // hideDescription={index === 0 || index === 1}
                  />
                </div>
              ))}
            </div>
            <div className="flex flex-col gap-4 md:w-[calc(50%-0.5rem)] lg:w-[calc(50%-0.5rem)]">
              {featuredArticles.slice(3, 9).map((article, index) => (
                <div
                  className="border-b-0.5 border-border last:border-b-0"
                  key={index}
                  // href={article.link}
                >
                  <Card
                    data={article}
                    title="medium"
                    layout="vertical"
                    textOnImage={false}
                    titleSize="medium"
                    description="large"
                    descriptionSize="small"
                    imageStyle="rounded"
                    hideImage={index === 0}
                    descriptionLineClamp="four"
                    titleLineClamp="three"
                    priority={false}
                    sizes="(max-width: 639px) calc(100vw - 2rem), (max-width: 767px) calc(100vw - 3rem), (max-width: 1023px) calc((100vw - 3rem) / 2 - 0.5rem), (max-width: 1279px) calc(((5 * (100vw - 4rem)) - 7rem) / 24 - 0.5rem), 254px"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      )}
    </section>
  );
};
